"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchWithViewState = exports.shouldDeferCompactHydration = exports.isCompactExtendedFilterState = void 0;
const view_query_params_1 = require("../../../common/view-query-params");
const isCompactExtendedFilter = (value) => (Boolean(value)
    && typeof value === 'object'
    && !Array.isArray(value)
    && value.selectAll === true
    && Array.isArray(value.excludedValues));
exports.isCompactExtendedFilterState = isCompactExtendedFilter;
const hasCompactChildrenSelection = (value) => (isCompactExtendedFilter(value));
const extractCompactChildCategoryIdsFromCategories = (value) => {
    if (!Array.isArray(value))
        return [];
    return value
        .map((category) => {
        if (!category || typeof category !== 'object' || Array.isArray(category)) {
            return null;
        }
        const typedCategory = category;
        if (typeof typedCategory.id !== 'string') {
            return null;
        }
        return hasCompactChildrenSelection(typedCategory.children) ? typedCategory.id : null;
    })
        .filter((id) => Boolean(id));
};
const hasCompactChildrenExclusionsInCategories = (value) => (Array.isArray(value)
    && value.some((category) => (Boolean(category)
        && typeof category === 'object'
        && !Array.isArray(category)
        && hasCompactChildrenSelection(category.children)
        && (category.children.excludedValues.length > 0))));
const extractCompactChildCategoryIds = (value) => {
    if (Array.isArray(value)) {
        return extractCompactChildCategoryIdsFromCategories(value);
    }
    if (!isCompactExtendedFilter(value)) {
        return [];
    }
    return extractCompactChildCategoryIdsFromCategories(value.categories);
};
const hasCompactChildrenExclusions = (value) => {
    if (Array.isArray(value)) {
        return hasCompactChildrenExclusionsInCategories(value);
    }
    if (!isCompactExtendedFilter(value)) {
        return false;
    }
    return hasCompactChildrenExclusionsInCategories(value.categories);
};
const shouldDeferCompactHydration = ({ allCategoryIds, allChildIdsByCategoryId, areAllL1CategoriesLoading, extendedFilter, }) => {
    const isCompactSelectAllWithExclusions = isCompactExtendedFilter(extendedFilter)
        && extendedFilter.excludedValues.length > 0;
    const hasCompactCategoryOverrides = isCompactExtendedFilter(extendedFilter)
        && Array.isArray(extendedFilter.categories)
        && extendedFilter.categories.length > 0;
    const hasCompactExtendedFilter = isCompactExtendedFilter(extendedFilter);
    const hasCompactChildExclusions = hasCompactChildrenExclusions(extendedFilter);
    const compactChildCategoryIds = extractCompactChildCategoryIds(extendedFilter);
    const areCompactChildCategoriesReady = compactChildCategoryIds.every((categoryId) => Object.prototype.hasOwnProperty.call(allChildIdsByCategoryId, categoryId));
    if (hasCompactExtendedFilter && areAllL1CategoriesLoading) {
        return true;
    }
    if ((isCompactSelectAllWithExclusions || hasCompactCategoryOverrides || hasCompactChildExclusions) && !allCategoryIds.length) {
        return true;
    }
    if (compactChildCategoryIds.length > 0 && !areCompactChildCategoriesReady) {
        return true;
    }
    return false;
};
exports.shouldDeferCompactHydration = shouldDeferCompactHydration;
const getSearchWithViewState = (search, encodedState) => {
    const searchParams = new URLSearchParams(search);
    if (encodedState) {
        searchParams.set(view_query_params_1.VIEW_QUERY_STATE_QUERY_KEY, encodedState);
    }
    else {
        searchParams.delete(view_query_params_1.VIEW_QUERY_STATE_QUERY_KEY);
    }
    const nextSearch = searchParams.toString();
    return nextSearch ? `?${nextSearch}` : '';
};
exports.getSearchWithViewState = getSearchWithViewState;
